<template>
  <div id="live-map-style-changer-button">
    <div class="btn-group-vertical side-btn mr-3">
      <!-- 地図スタイル -->
      <vx-tooltip :text="styleName" position="left">
        <vs-button
          class="cursor-pointer map-style-select mb-1 color-grey"
          style="height: 60px; width: 60px;"
          @click.stop="onChangeMapStyle()"
        >
          <img :src="styleImg" class="style-icon" />
        </vs-button>
      </vx-tooltip>
    </div>
  </div>
</template>

<script>
import LocalDbService from "@/services/localDbService";
import FireStoreService from "@/services/fireStoreService";
import { mapGetters } from "vuex";

// Mixins
import {LayerMixin} from "@/mixins";

export default {
  mixins: [LayerMixin],
  props: {
    map: Object,
    mapbox: Object
  },
  data() {
    return {
      styleType: 1,
      imageDefault: require("@/assets/images/pages/map/streetmap.png"),
      imageSatellite: require("@/assets/images/pages/map/sattellite.png")
    };
  },
  async mounted() {
    let style = await LocalDbService.getMapStyle();
    await this.setMapStyle(style);
  },
  computed: {
    ...mapGetters({
      mapStyle: "enterpriseMapSetting/getStyle"
    }),
    styleName() {
      return this.styleType === 1 ? "航空地図" : "標準地図";
    },
    styleImg() {
      return this.styleType === 1 ? this.imageSatellite : this.imageDefault;
    }
  },
  methods: {
    onChangeMapStyle() {
      if (this.mapStyle === this.MAP_DEFAULT_STYLE_URL) {
        this.$store.dispatch(
          "enterpriseMapSetting/fetchStyle",
          this.MAP_SATELLITE_STYLE_URL
        );
        FireStoreService.saveMapStyle(this.MAP_SATELLITE_STYLE_URL);
        LocalDbService.saveMapStyle(this.MAP_SATELLITE_STYLE_URL);
        this.setMapStyle(this.MAP_SATELLITE_STYLE_URL)
      } else {
        this.$store.dispatch(
          "enterpriseMapSetting/fetchStyle",
          this.MAP_DEFAULT_STYLE_URL
        );
        FireStoreService.saveMapStyle(this.MAP_DEFAULT_STYLE_URL);
        LocalDbService.saveMapStyle(this.MAP_DEFAULT_STYLE_URL);
        this.setMapStyle(this.MAP_DEFAULT_STYLE_URL)
      }
    },
    async setMapStyle(style) {
      if (style === this.MAP_DEFAULT_STYLE_URL) {
        this.styleType = 1;
      } else if (style === this.MAP_SATELLITE_STYLE_URL) {
        this.styleType = 2;
      }
    }
  }
};
</script>

<style lang="scss">
#live-map-style-changer-button {
  z-index: 58000;
  .vs-sidebar {
    top: 62px;
    position: fixed;
    z-index: 58000;
    width: 400px;
    max-width: 90vw;
    // @apply shadow-lg;
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
      0 5px 15px 0 rgba(0, 0, 0, 0.08);
  }
}
.side-btn {
  .vs-button {
    border-radius: 5px 5px 5px 5px;
    box-shadow: none;
  }
  position: fixed;
  top: 155px;
  right: 0;
  z-index: 50000;
}
.style-icon {
  width: 56px;
  height: 56px;
  margin-left: -1.1rem;
  margin-top: -0.85rem;
  border-radius: 5px 5px 5px 5px;
}
.color-grey {
  background-color: #cfccc6 !important;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
